import { render, staticRenderFns } from "./LogoImg.vue?vue&type=template&id=45ee3eb4&scoped=true&"
var script = {}
import style0 from "./LogoImg.vue?vue&type=style&index=0&id=45ee3eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ee3eb4",
  null
  
)

export default component.exports